export const LINK_REGEX_CONTENT_BLOCK = /\]\(([^)]+)\)/;
export const MIN_LENGTH_REGEX_MATCH = 2;
export const MATCHED_STRING_INDEX = 1;